import React from 'react';
import { graphql } from 'gatsby';
import { Section } from '../../Section';
import { CTACard as CTACardComponent } from '../../CtaCard';

export const CTACard = ({ data, ...rest }) => (
  <Section contained narrow={data.width === 'narrow'} {...rest}>
    <CTACardComponent {...data} inlineButton />
  </Section>
);

export const CtaCardQuery = graphql`
  fragment CtaCard on KFH_UmbracoCtaCardComponentType {
    title
    lead
    backgroundColour
    button {
      ...Button
    }
    secondaryButton {
      ...Button
    }
    image {
      altText
      localFile {
        gatsbyImage(
          width: 192
          height: 192
          layout: CONSTRAINED
          placeholder: NONE
          quality: 80
          backgroundColor: "#F5F5F5"
        )
      }
    }
  }
`;
